module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.629a55a7.ttf";